<template>
  <div class="container">
    <Header
      :title="'Section 2: Sharing Your Story'"
      :details="
        'This section helps to gauge your comfort level in sharing your story. You do not need to have previous public speaking experience to participate in the Speakers Bureau.'
      "
    />
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <label>
          <strong>Have you ever spoken publicly about your experience?</strong>
          <br />
          <em
            >For example, speaking to a community group or being interviewed by
            a journalist.</em
          >
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="publiclyExperience"
              :checked="values.publiclyExperienceRadio1"
              @change="
                e =>
                  handleValueChanged(
                    'publiclyExperienceRadio1',
                    e.target.checked
                  )
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="publiclyExperience"
              :checked="values.publiclyExperienceRadio2"
              @change="
                e =>
                  handleValueChanged(
                    'publiclyExperienceRadio2',
                    e.target.checked
                  )
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label"
          >If applicable, please list specific media outlets and/or where your
          story has appeared.</label
        >
        <textarea
          class="form-control"
          rows="2"
          :value="values.mediaOutlets"
          @keyup="e => handleValueChanged('mediaOutlets', e.target.value)"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 col-lg-6">
        <label>
          <strong
            >Have you ever been involved with efforts to change or pass
            legislation?</strong
          >
          <br />
          <em
            >For example, meetings with lawmakers or grassroots efforts at a
            state or national level.</em
          >
        </label>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="legislation"
              :checked="values.legislationRadio1"
              @change="
                e => handleValueChanged('legislationRadio1', e.target.checked)
              "
            />
            Yes
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              name="legislation"
              :checked="values.legislationRadio2"
              @change="
                e => handleValueChanged('legislationRadio2', e.target.checked)
              "
            />
            No
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label"
          >If yes, what issue(s) were you advocating for?</label
        >
        <textarea
          class="form-control"
          rows="2"
          :value="values.legislationIssues"
          @keyup="e => handleValueChanged('legislationIssues', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label"
          >Who did you speak or work with (i.e. Congressional office staff or
          advocacy group)?</label
        >
        <textarea
          class="form-control"
          rows="2"
          :value="values.legislationSpokeTo"
          @keyup="e => handleValueChanged('legislationSpokeTo', e.target.value)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">Additional details</label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.legislationAdditionalDetails"
          @keyup="
            e =>
              handleValueChanged('legislationAdditionalDetails', e.target.value)
          "
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >Are there any specific policy areas or topics that you especially
            want to advocate for?</strong
          >
          <br />
          <em
            >For example, a particular piece of legislation, campus safety,
            reporting, etc.</em
          >
        </label>
        <textarea
          class="form-control"
          rows="2"
          :value="values.advocate"
          @keyup="e => handleValueChanged('advocate', e.target.value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Application/SectionHeader";
import { SectionTwo } from "@/typings/application";

export default {
  name: "sectionTwo",
  components: {
    Header
  },
  props: {
    values: {
      type: SectionTwo,
      required: true,
      default: () => {
        return new SectionTwo();
      }
    },
    onValueChanged: {
      type: Function,
      requried: true,
      default: () => {}
    }
  },
  methods: {
    handleValueChanged(name, value) {
      this.onValueChanged("section2", name, value);
      if (name.includes("Radio")) {
        // Ensures that only one radio within a radio group is selected at a
        // time.
        const radio = name.split("Radio");
        const index = (parseInt(radio[1]) % 2) + 1;
        this.onValueChanged("section2", `${radio[0]}Radio${index}`, false);
      }
    }
  }
};
</script>

<style></style>
